
	frappe.templates['resource_header'] = `<div class="flex align-items-start" style="min-height: var(--resource-row-height, 0px);">
	{% if (planning.list_view.resource == "_assign") { %}
		<div class="mr-2">{{ frappe.avatar(arg.resource.id) }}</div>
	{% } %}
	<div>{{ arg.resource.title }}</div>
</div>
`;
